// FAKE NOTIFICATION
export const PROD_FAKE_NOTIFICATION_FLOW_HASH_ID = 'lP7VrjED';
export const STAGING_FAKE_NOTIFICATION_FLOW_HASH_ID = 'D3OD1oEN';
// COMMAND BAR INSTALLABLE
export const PROD_COMMAND_BAR_INSTALLABLE_ID = 'YP5X6D1';
export const STAGING_COMMAND_BAR_INSTALLABLE_ID = 'a3AaP3V';

/* Get to know ply section */
import OnBoardingBuildYourFirst from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetBuilding/OnBoardingBuildYourFirst.vue';
import OnBoardingWhatsPossible from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetBuilding/OnBoardingWhatsPossible.vue';
import OnBoardingGetToKnowAddOns from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/OnBoardingGetToKnowAddOns.vue';
import OnBoardingGetToKnowNotifications from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/OnBoardingGetToKnowNotifications.vue';
import OnBoardingGetToKnowTools from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/OnBoardingGetToKnowTools.vue';
import OnBoardingWelcomeToPlyStep from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/OnBoardingWelcomeToPlyStep.vue';
//Tools sub-steps
import OnBoardingGetToKnowInstallTool from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/Tools/OnBoardingGetToKnowInstallTool.vue';
import OnBoardingGetToKnowRunTool from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/Tools/OnBoardingGetToKnowRunTool.vue';
import OnBoardingGetToKnowToolsEditShortcut from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/GetToKnowPly/Tools/OnBoardingGetToKnowToolsEditShortcut.vue';
/* Get to know ply section */

/* Set up your workspace */
import OnBoardingFavoriteApps from './OnBoardingFlow/OnBoardingSection/OnBoardingSteps/SetUp/OnBoardingFavoriteApps.vue';
/* Set up your workspace */

/* Get building */
/* Get building */

export const reformatGuidedTutorials = (guidedTutorials) =>
	guidedTutorials.map((gt) => ({
		...gt,
		id: gt.video_link,
		minutesToComplete: Number(gt.duration.split(':')[1]),
	}));

export const getOnBoardingItems = (guidedTutorials) => {
	const newTutorials = reformatGuidedTutorials(guidedTutorials);

	return [
		{
			title: 'Get to know Ply',
			iconName: 'get-to-know-ply',
			steps: [
				{
					id: '1a',
					minutesToComplete: 5,
					title: 'Welcome to Ply',
					component: OnBoardingWelcomeToPlyStep,
				},
				{
					id: '1b',
					title: 'Add-ons',
					minutesToComplete: 2,
					iconName: 'on-boarding-add-ons',
					component: OnBoardingGetToKnowAddOns,
				},
				{
					id: '1c',
					title: 'Tools',
					minutesToComplete: 2,
					component: OnBoardingGetToKnowTools,
					iconName: 'on-boarding-tools',
					subSteps: [
						{
							id: '1c1',
							component: OnBoardingGetToKnowToolsEditShortcut,
						},
						{
							id: '1c2',
							component: OnBoardingGetToKnowInstallTool,
						},
						{
							id: '1c3',
							bottomSection: true,
							component: OnBoardingGetToKnowRunTool,
						},
					],
				},
				{
					id: '1d',
					minutesToComplete: 3,
					title: 'Notifications',
					iconName: 'on-boarding-notifications',
					component: OnBoardingGetToKnowNotifications,
				},
			],
		},
		{
			title: 'Set up your workspace',
			iconName: 'setup-your-workspace',
			steps: [
				{
					id: '2a',
					minutesToComplete: 1,
					// subTitle: 'Add at least 3',
					title: 'Which apps do you use?',
					component: OnBoardingFavoriteApps,
				},
			],
		},
		{
			title: 'Get building',
			iconName: 'get-building',
			steps: [
				{
					id: '3a',
					minutesToComplete: 5,
					component: OnBoardingWhatsPossible,
					title: "What's possible and where to start",
				},
				{
					id: '3b',
					subSteps: newTutorials,
					title: 'Build your first feature',
					component: OnBoardingBuildYourFirst,
					minutesToComplete: newTutorials.reduce((sum, gt) => sum + gt.minutesToComplete, 0),
				},
			],
		},
	];
};
